<template>
    <div class="home">
        <!--  banner    -->
        <div class="banner-box">
            <el-carousel
                :height=" '250px'"
                :interval="5000"
                indicator-position="none"
            >
                <el-carousel-item v-for="(item, i) in newLists" :key="i">
                    <div ref="bannerImg">
                        <ul class="flex flex-align-center">
                            <li
                                v-for="(k, i) in item"
                                :key="i"
                                @click="handleDetail(k)"
                            >
                                <img :src="k.cover" />
                            </li>
                        </ul>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!--  书籍推荐      -->
        <div class="books-box">
            <span  class="book-link" @click="handleMoreClick" >+更多</span>
            <div class="books-lists flex">
                <div
                    v-for="(item, i) in commendLists"
                    class="books-item"
                    :key="i"
                    @click="handleDetail(item)"
                >
                    <img :src="item.cover" />
                    <p class="line-clamp1">{{ item.title }}</p>
                </div>
            </div>
        </div>
        <!--   书籍排行    -->
        <rankBox  class="rank1"></rankBox>

        <!--   最新活动     -->
        <!-- <div class="active-box">
            <div class="flex flex-space-between flex-align-center">
                <h2>最新活动</h2>
                <i @click="goNextPage('/active')" class="cursor-pointer"
                    >+更多</i
                >
            </div>
            <div
                v-if="active.id"
                class="active-content flex flex-space-between"
            >
                <img :src="active.cover" />
                <div class="active-content-text">
                    <p  class="line-clamp1">{{ active.description }}</p>
                </div>
                <div class="active-content-date">
                    <p>{{ active.beginTime }}~{{ active.endTime }}</p>
                </div>
            </div>
            <div class="none-data" v-else>暂无数据~</div>
        </div> -->
        <!--   教育在线     -->
        <!-- <div class="active-box">
            <div class="flex flex-space-between flex-align-center">
                <h2>教育在线</h2>
                <i class="cursor-pointer" @click="goNextPage('/educate')"
                    >+更多</i
                >
            </div>
            <ul v-for="item in zxLists" :key="item.id">
                <li class="tc">
                    <img :src="item.picUrl" alt="" srcset="" />
                    <p class="line-clamp1">{{ item.title }}</p>
                </li>
            </ul>
            <div class="none-data" v-if="!zxLists.length">暂无数据~</div>
        </div> -->
    </div>
</template>
<script setup>
// 响应式状态
import { onMounted, reactive, ref, toRefs, computed, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import {
    articleLists,
    classification,
    antiqueLists,
    getHomeBanner,
    getActivityLists,
    getEbookLists
} from '@/api/index';
import moment from 'moment';
import RankBox from '@/components/rankBox.vue';
import useGoDetail from '@/minixs/goDetail';

const router = useRouter();

const state = reactive({
    culturalRelic: 1,
    zxLists: [],
    wwLists: [],
    bannerLists: [],
    active: {},
    bannerImgHeight: 947,

    newLists: [],
    commendLists: [],
    rankLists: []
});

// 跳转资讯
const handleZX = () => {
    router.push('/information');
};
// 跳转资讯详情
const handleZxDetail = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        router.push('/information/detail?id=' + item.id);
    }
};

const goNextPage = (url) => {
    router.push(url);
};

// 获取资讯列表
const getZxLists = () => {
    articleLists({
        pageNo: 1,
        pageSize: 4,
        categoryId: 2
    }).then(({ data }) => {
        const _data = data?.list || [];

        _data.forEach((element) => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        state.zxLists = _data;
    });
};
// 获取活动列表
const getLists = () => {
    const data = {
        pageNo: 1,
        pageSize: 10
    };
    getActivityLists(data).then(({ data }) => {
        const _data = data?.list || [];
        _data.forEach(item => {
            // 开始时间
            item.beginTime = moment(item.beginTime).format('YYYY-MM-DD');
            // 结束时间
            item.endTime = moment(item.endTime).format('YYYY-MM-DD');
        });
        state.active = _data[0] || {};
    });
};

/** 图书列表的获取**/
const getNewLists = () => {
    // 新书
    getEbookLists().then(({ data }) => {
        const _data = chunkArray(data?.list || [], 3);
        state.newLists = _data;
    });
    // 推荐
    getEbookLists({
        pageNo: 1,
        pageSize: 4,
        sortType: 2
    }).then(({ data }) => {
        state.commendLists = data?.list || [];
    });

};

// 更多图书的点击
const handleMoreClick = () => {
    console.log('handleMoreClick');
    router.push('/bookSearch');
};

/** 详情页的跳转 使用 mixin 的跳转方法**/
const { handleDetail } = useGoDetail();

const handleCulturalRelic = (item) => {
    if (item.classification === state.culturalRelic) return;
    state.culturalRelic = item.classification;
    getWwLists();
};

function chunkArray (array, size) {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
    }
    return result;
}

// 获取文物列表
const getWwLists = () => {
    antiqueLists({
        pageNo: 1,
        pageSize: 9,
        classification: state.culturalRelic
    }).then(({ data }) => {
        const _data = chunkArray(data?.list || [], 3);

        state.wwLists = _data;
    });
};
const bannerImg = ref(null);
const getBanner = () => {
    getHomeBanner({ position: 1 }).then(({ data }) => {
        state.bannerLists = data;
    });
};

const handleBannerDetail = (item) => {
    router.push(item.url);
};

const {
    zxLists,
    wwLists,
    culturalRelicLists,
    culturalRelic,
    bannerLists,
    bannerImgHeight,
    active,
    newLists,
    commendLists,
    rankLists
} = toRefs(state);

// 生命周期钩子
onMounted(() => {
    getZxLists();
    // getWwTypes()
    getBanner();
    getLists();
    getNewLists();
   
});
</script>
<style scoped lang="scss">
.home {
    width: 1200px;
    margin: auto;
}
.banner-box{
    width: 100%;
    height: 391px;
    margin-top: 30px;
    margin-bottom: 30px;
    background: url("~@/assets/imgs/swiper-box.png") no-repeat;
    background-size: 100% 100%;

    .banner-img {
        width: 100%;
        height: 391px;
    }
    ul {
        height: 391px;
        margin-left: 132px;
        gap: 23px;
        li {
            width: 212px;
            height: 311px;
            background: #f2f2f2;
            text-align: center;
            padding: 12px;
            box-sizing: border-box;

            img {
                width: 188px;
            }
        }
    }
}
.books-box {
    width: 100%;
    height: 591px;
    background: url("~@/assets/imgs/index-bg2.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: 39px;
    position: relative;
    overflow: hidden;

    .book-link {
        font-family: Source Han Sans CN;
        color: #313131;
        font-size: 24px;
        position: absolute;
        top: 30px;
        right: 20px;
        cursor: pointer;
    }
    .books-lists {
        margin-top: 86px;
        margin-left: 93px;
        background: transparent;
        display: flex;
        flex-wrap: wrap;
        gap: 28px;
        .books-item {
            width: 23%;
            flex-shrink: 0;
            background: #ffffff;
            padding: 19px 17px;
            box-sizing: border-box;

            img {
                width: 100%;
                height: 340px;
            }
            p {
                width: 100%;
            }
            
        }
    }
}
.active-box {
    margin-bottom: 80px;
    h2 {
        font-weight: 500;
        color: #292929;
        font-size: 28px;
        position: relative;

        &:after {
            content: "";
            display: block;
            width: 112px;
            height: 5px;
            background: #188b97;
            position: absolute;
            left: 0;
            bottom: -9px;
        }
    }
    i {
        font-style: normal;
        color: #292929;
        font-size: 18px;
    }
    .active-content {
        margin-top: 33px;

        img {
            width: 530px;
            height: 331px;
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        }
        .active-content-text {
            color: #202020;
            font-size: 18px;
            width: 357px;
            text-align: left;
            p {
                margin-bottom: 34px;
                &:last-child {
                    margin-bottom: 0 !important;
                }
            }
        }
        &-date {
            p {
                margin-bottom: 34px;
                &:last-child {
                    margin-bottom: 0 !important;
                }
            }
        }
    }
    ul {
        margin-top: 33px;
        display: grid;
        grid-template-columns: repeat(3, 32%);
        gap: 22px;
        box-sizing: border-box;
        li {
            width: 100%;
            background: #ffffff;
            border: 1px solid;
            border-color: #e5e5e5;

            img {
                width: 100%;
                height: 222px;
            }
            p {
                width: 100%;
                height: 60px;
                color: #292929;
                font-size: 18px;
                line-height: 60px;
            }
        }
    }
}
.rank1 {
    background: url("~@/assets/imgs/index-bg3.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: 39px;
}
.none-data {
    margin-top: 20px;
    font-size: 12px;
    color: #333;
}
</style>
